import { isProduction } from '@watershed/config/env';
import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

type DevEnv =
  | 'local-dev'
  | 'dev-proxy'
  | 'production-preview'
  | 'production'
  | 'production-preview-gcp';

const labels: Record<DevEnv, string> = {
  'local-dev': 'Local',
  'dev-proxy': 'Dev Proxy',
  'production-preview': 'Production - Preview',
  'production-preview-gcp': 'Production - Preview (GCP)',
  production: 'Production',
};

export const getCurrentDevEnv: () => DevEnv = () => {
  if (
    window.location.hostname.includes('preview') &&
    getPublicRuntimeConfig('NEXT_PUBLIC_CLOUD_PROVIDER') === 'gcp'
  ) {
    return 'production-preview-gcp';
  }

  if (window.location.hostname.includes('preview')) {
    return 'production-preview';
  }

  if (isProduction()) {
    return 'production';
  }

  if (window.location.hostname.startsWith('localhost')) {
    return 'local-dev';
  }

  if (window.location.hostname.startsWith('proxy')) {
    return 'dev-proxy';
  }

  // If we can't positively affirm we're working locally,
  // fall back and assume we're in a production-like env.
  return 'production';
};

export const getCurrentDevEnvLabel = () => {
  return labels[getCurrentDevEnv()];
};
